import { object, string, boolean, array, InferType } from "yup";

import { format as jFormat } from "date-fns-jalali";

export const searchFilterSchema = object()
  .shape({
    checkin: string().required("تاریخ رفت الزامی می باشد"),
    checkout: string().required("تاریخ برگشت الزامی می باشد"),
    rooms: array()
      .required()
      .default([{ adult: 2, child: [] }]),
  })
  .required();

export const searchDefaultValue = {
  checkin: jFormat(new Date(), "yyyy/MM/dd"),
  checkout: jFormat(
    new Date(new Date().getTime() + 48 * 60 * 60 * 1000) /* 2days */,
    "yyyy/MM/dd"
  ),

  rooms: [{ adult: 2, child: [] }],
};

export type SearchFilter = InferType<typeof searchFilterSchema>;
